import React from 'react'

const InvoiceSettings = () => {
  return (
    <div>InvoiceSettings</div>
  )
}

export default InvoiceSettings